export enum GENDER {
	MALE = "MALE",
	FEMALE = "FEMALE",
	OTHER = "OTHER",
}

export enum ROLE {
	SUPER_ADMIN = "SUPER_ADMIN",
	ADMIN = "ADMIN",
	STAFF = "STAFF",
}

export enum DISPLAY_PREFERENCE_TYPE {
	AGENT = "AGENT",
	CLIENT = "CLIENT",
	SUPPLIER = "SUPPLIER",
	RECEIVER = "RECEIVER",
	PRODUCT = "PRODUCT",
	SERVICE_AGENT = "SERVICE_AGENT",
	SERVICE_CLIENT = "SERVICE_CLIENT",
	ACCOUNT_TRANSACTION = "ACCOUNT_TRANSACTION",
	PAYMENT_ATTACHMENT = "PAYMENT_ATTACHMENT",
	FILE = "FILE",
}

export enum DISPLAY_PREFERENCE_SECTION_DISPLAY {
	GRID = "GRID",
	STACK = "STACK",
	TABLE = "TABLE",
}

export enum CUSTOM_FIELD_TYPE {
	TEXT_SINGLE = "TEXT_SINGLE",
	TEXT_MULTI = "TEXT_MULTI",
	SELECT_SINGLE = "SELECT_SINGLE",
	SELECT_MULTI = "SELECT_MULTI",
	DATETIME = "DATETIME",
}

export enum CUSTOM_FIELD_MODEL {
	COMPANY = "COMPANY",
	USER = "USER",
	AGENT_INFO = "AGENT_INFO",
	AGENT_ADDRESS = "AGENT_ADDRESS",
	AGENT_CONTACT = "AGENT_CONTACT",
	CLIENT_INFO = "CLIENT_INFO",
	CLIENT_ADDRESS = "CLIENT_ADDRESS",
	CLIENT_CONTACT = "CLIENT_CONTACT",
	RECEIVER_INFO = "RECEIVER_INFO",
	RECEIVER_ADDRESS = "RECEIVER_ADDRESS",
	RECEIVER_CONTACT = "RECEIVER_CONTACT",
	SUPPLIER_INFO = "SUPPLIER_INFO",
	SUPPLIER_ADDRESS = "SUPPLIER_ADDRESS",
	SUPPLIER_CONTACT = "SUPPLIER_CONTACT",
	FILE = "FILE",
}

export enum DISCOUNT_TYPE {
	AMOUNT = "AMOUNT",
	PERCENTAGE = "PERCENTAGE",
}

export enum FIX_DISCOUNT_TYPE {
	PRODUCTS = "PRODUCTS",
	CATEGORIES = "CATEGORIES",
	PRODUCT_TYPES = "PRODUCT_TYPES",
	PRODUCT_OPTIONS = "OPTIONS",
	AGENTS = "AGENTS",
	CLIENTS = "CLIENTS",
	ORDERS = "ORDERS",
}

export enum FINANCE_REPORT_TYPE {
	MONTHLY_STATEMENT = "MONTHLY_STATEMENT",
	GROUP = "GROUP",
}

export enum COUNTER_TYPE {
	FILE = "FILE",
	INVOICE = "INVOICE",
	RECEIPT = "RECEIPT",
	MONTHLY_STATEMENT = "MONTHLY_STATEMENT",
	ACCOUNT_TRANSACTION = "ACCOUNT_TRANSACTION",
	PURCHASE_ORDER = "PURCHASE_ORDER",
	PROCUREMENT_INVOICE = "PROCUREMENT_INVOICE",
	TASK = "TASK",
}

export enum FILE_VIEW_PREFERENCE_KEYS {
	TABLE_VIEW = "TABLE_VIEW",
	KANBAN_VIEW = "KANBAN_VIEW",
}

export enum PAYMENT_VERIFICATION_STATUS {
	PENDING = "PENDING",
	PARTIAL = "PARTIAL",
	COMPLETE = "COMPLETED",
	VOID = "VOID",
}

export enum ACCOUNT_TRANSACTION_PAYMENT_STAGE {
	DEPOSIT_PAYMENT = "DEPOSIT_PAYMENT",
	PARTIAL_PAYMENT = "PARTIAL_PAYMENT",
	FINAL_PAYMENT = "FINAL_PAYMENT",
}

export enum PAYMENT_VERIFICATION_UPLOAD_STAGE {
	DEPOSIT_PAYMENT = "DEPOSIT_PAYMENT",
	PARTIAL_PAYMENT = "PARTIAL_PAYMENT",
	FINAL_PAYMENT = "FINAL_PAYMENT",
}

export enum PAYMENT_VERIFICATION_UPLOAD_RECEIVED_STATUS {
	PENDING = "PENDING",
	VERIFIED = "VERIFIED",
}

export enum USER_PERMISSIONS {
	EDIT_PAYMENT_TYPE = "EDIT_PAYMENT_TYPE",
	EDIT_PAYMENT_AMOUNT = "EDIT_PAYMENT_AMOUNT",
	VIEW_AGENT = "VIEW_AGENT",
	CREATE_AGENT = "CREATE_AGENT",
	EDIT_AGENT = "EDIT_AGENT",
	DELETE_AGENT = "DELETE_AGENT",
	VIEW_CLIENT = "VIEW_CLIENT",
	CREATE_CLIENT = "CREATE_CLIENT",
	EDIT_CLIENT = "EDIT_CLIENT",
	DELETE_CLIENT = "DELETE_CLIENT",
	VIEW_PRODUCT = "VIEW_PRODUCT",
	CREATE_PRODUCT = "CREATE_PRODUCT",
	EDIT_PRODUCT = "EDIT_PRODUCT",
	DELETE_PRODUCT = "DELETE_PRODUCT",
	VIEW_REPORT = "VIEW_REPORT",
	VIEW_FINANCE = "VIEW_FINANCE",
	VIEW_MONTHLY_STATEMENT = "VIEW_MONTHLY_STATEMENT",
	CREATE_MONTHLY_STATEMENT = "CREATE_MONTHLY_STATEMENT",
	EDIT_MONTHLY_STATEMENT = "EDIT_MONTHLY_STATEMENT",
	DELETE_MONTHLY_STATEMENT = "DELETE_MONTHLY_STATEMENT",
	VIEW_ALL_ASSIGNEE_TASKS = "VIEW_ALL_ASSIGNEE_TASKS",
	ACCESS_ACCOUNT = "ACCESS_ACCOUNT",
	ACCESS_PAYMENT_ATTACHMENT = "ACCESS_PAYMENT_ATTACHMENT",
	ACCESS_TRANSACTION = "ACCESS_TRANSACTION",
	DELETE_PAYMENT_ATTACHMENT_BEFORE_PAYMENT = "DELETE_PAYMENT_ATTACHMENT_BEFORE_PAYMENT",
	DELETE_PAYMENT_ATTACHMENT_AFTER_PAYMENT = "DELETE_PAYMENT_ATTACHMENT_AFTER_PAYMENT",
}

export enum UPLOAD_PAYMENT_ATTACHMENT_MODE {
	ACCOUNT_TRANSACTION = "ACCOUNT_TRANSACTION",
	FILE = "FILE",
	NONE = "NONE",
}
